import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";

import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";

import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { EditarCategories, getAccountType, GuardarCategories } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

const CategoriesCRUD = ({
    showDialog,
    selected,
    setSelected,
    setShowDialog,
    getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [acounts, setAccounts] = useState([]);
  const [dialogTitle, setDialogTitle] = useState('');

  const initialValues = {
    IdCategoria: -1,
    IdStatus: selected?.IdStatus ? selected?.IdStatus : 5,
    StatusName: selected?.StatusName ? selected?.StatusName : 'Activo',
    Type: '',
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const estadosTempo = await getEstadosCategory("General");
    let est = estadosTempo.filter((i) => i?.IdStatus !== 7);

    let estadoInicial;
    if (selected?.IdCategoria) {
      setDialogTitle("Editar Categoría");
      estadoInicial = estadosTempo.find(
        (e) => e.IdStatus === selected?.IdStatus
      );
    } else {
      setDialogTitle("Agregar Categoría");
      estadoInicial = estadosTempo[0];
    }
    setEstados(est);

    const accountTempo = await getAccountType();
    setAccounts(accountTempo);

    setValues({
      ...selected,
      IdCategoria: selected?.IdCategoria > 0 ? selected?.IdCategoria : -10,
      IdStatus: estadoInicial?.IdStatus,
      StatusName: estadoInicial,
      IdType: selected?.IdType ? selected?.IdType : null,
      Type: selected?.Type ? selected?.Type : "",
    });
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null)
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Categoria) {
        error.Categoria = true;
        error.error = true;
    }
    if (!values.Type?.IdType && !values?.IdType) {
        error.IdType = true;
        error.error = true;
    }
    if (!values.StatusName?.IdStatus && !values?.IdStatus) {
        error.IdStatus = true;
        error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){

        const Datos = {
            IdCategoria: values?.IdCategoria ? values?.IdCategoria : -100,
            CodigoCategoria: values?.CodigoCategoria,
            Categoria: values?.Categoria,
            IdType: values?.Type?.IdType || values?.IdType,
            IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
            Description: values?.Description,
            IdUserCreate: userAuth?.IdUser,
            IdUserEdit: userAuth?.IdUser,
        }

        setLoading(true)
        if(Datos?.IdCategoria > 0){
            const respuesta = await EditarCategories(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Editado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }else{
            const respuesta = await GuardarCategories(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }

    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);


  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h3 className="mx-4">{dialogTitle}</h3>
            </div>
            <Toast ref={toast}/>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="CodigoCategoria"
                    value={values.CodigoCategoria}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.CodigoCategoria ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoCategoria">Código</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Categoria"
                    value={values.Categoria}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Categoria ? "p-invalid" : ""}
                  />
                  <label htmlFor="Categoria">Categoría</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"Type"}
                        value={values.Type}
                        items={acounts}
                        field={"Type"}
                        label={"Tipo de Cuenta"}
                        handleInputChange={handleInputChange}
                        className={error.IdType ? "p-invalid" : ""}
                    />
                    </span>
                </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StatusName"}
                    value={values.StatusName}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    enable={dialogTitle !== 'Agregar Categoría'}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                    <InputText
                        name="Description"
                        value={values.Description}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.Description ? "p-invalid" : ""}
                    />
                    <label htmlFor="Description">Descripción</label>
                    </span>
                </div>
            </div>

          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CategoriesCRUD;
